import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router';

import Login from 'src/views/Login.vue';
import Top from 'src/views/Top.vue';

import AdminTop from 'src/views/Admin/Top.vue';
import AdminUsers from 'src/views/Admin/Users.vue';
import AdminComments from 'src/views/Admin/Comments.vue';
import AdminDevices from 'src/views/Admin/Devices.vue';
import AdminGroups2 from 'src/views/Admin/Groups2.vue';
import AdminGroups3 from 'src/views/Admin/Groups3.vue';
import AdminTags from 'src/views/Admin/Tags.vue';
import AdminMovieGroups from 'src/views/Admin/MovieGroups.vue';
import AdminCommentTypes from 'src/views/Admin/CommentTypes.vue';

import DevDebugTop from 'src/views/DevDebug/Top.vue';

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/',
    name: 'Top',
    component: Top,
  },
  {
    path: '/admin',
    name: 'AdminTop',
    component: AdminTop,
    children: [
      {
        path: 'users',
        name: 'AdminUsers',
        component: AdminUsers,
      },
      {
        path: 'comments',
        name: 'AdminComments',
        component: AdminComments,
      },
      {
        path: 'devices',
        name: 'AdminDevices',
        component: AdminDevices,
      },
      {
        path: 'groups2',
        name: 'AdminGroups2',
        component: AdminGroups2,
      },
      {
        path: 'groups3',
        name: 'AdminGroups3',
        component: AdminGroups3,
      },
      {
        path: 'movie_groups',
        name: 'AdminMovieGroups',
        component: AdminMovieGroups,
      },
      {
        path: 'tags',
        name: 'AdminTags',
        component: AdminTags,
      },
      {
        path: 'comment_types',
        name: 'AdminCommentTypes',
        component: AdminCommentTypes,
      },
    ],
  },
  {
    path: '/dev-debug',
    name: 'DevDebugTop',
    component: DevDebugTop,
  },
  {
    path: '/dev-debug/ui-showcase',
    name: 'DevDebugUIShowcase',
    component: () => import('src/views/DevDebug/UIShowcase.vue'),
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login',
  },
] satisfies RouteRecordRaw[];

export default createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});
